import {localLanguageEn, localLanguageRu} from "./language.js";

let scoreHTML = document.querySelector('.results-main__result__score');
let suggestion = document.getElementById('suggestion');
let resultsLink = document.querySelector('.results-main__link');

if (scoreHTML !== null) {
  scoreHTML.textContent = `${localStorage.getItem('score') === null ? 0 : localStorage.getItem('score')}`;
  if (30 == scoreHTML.textContent) {
    suggestion.textContent = localStorage.getItem("lang") === null ?  localLanguageRu.results.congrats : localStorage.getItem("lang") === "Русский" ? localLanguageRu.results.congrats : localLanguageEn.results.congrats;
    resultsLink.textContent = localStorage.getItem("lang") === null ?  localLanguageRu.results.main : localStorage.getItem("lang") === "Русский" ? localLanguageRu.results.main : localLanguageEn.results.main;
    resultsLink.href = './index.html';
  }
}

